import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { FLOW_MODES, type Appointment } from 'types/appointments';
import { type LocationState } from './types';

interface EditAppointmentProps {
  appointment: Appointment;
  onSuccess: (state: LocationState) => void;
}

export const EditAppointmentDialog = ({
  appointment,
  onSuccess,
}: EditAppointmentProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  const isEditEnabled = !appointment.immovable;

  const handleEditAppointment = (): void => {
    onSuccess({
      appointment,
      psychologist: appointment.psychologist?.psychologist,
      patientId: appointment.patientId,
      flow: FLOW_MODES.edit,
    });
  };

  if (!isEditEnabled) {
    return (
      <Dialog
        open
        title={t('EditAppointment.Dialog.disabled.heading')}
        description={t('EditAppointment.Dialog.disabled.body')}
      />
    );
  }

  return (
    <Dialog
      open
      hideClose
      title={t('EditAppointment.Dialog.heading')}
      description={t('EditAppointment.Dialog.body')}
      secondaryAction={{
        label: t('EditAppointment.Dialog.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('EditAppointment.Dialog.confirm'),
        action: handleEditAppointment,
        variant: 'primary',
      }}
    />
  );
};
